import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {getDetailPackageSaga} from "./detailPackageSaga";

export default function* detailPackageWatcher() {
  yield takeLatest(ActionsTypes.GET_DETAIL_PACKAGE, getDetailPackageSaga);
}
